module.exports = __webpack_public_path__ + "static/media/08A.c7fcbf21.png";